<template>
    <div v-if="deadline.menu.can_edit">
        <b-select
            :key="key"
            ref="assignment"
            v-model="form.assigned_to_id"
            size="sm"
            :options="accountingFirmUsers"
            :class="reactiveClass"
            @change="saveDeadline"
        >
        </b-select>
    </div>
    <div v-else>
        {{ deadline.assigned_to.name }}
    </div>
</template>

<script>
import { mapState } from 'vuex'
import TableFormHandler from '../../../../common/mixins/TableFormHandler'

export default {
    name: 'AssignmentForm',

    mixins: [TableFormHandler],

    props: {
        deadline: {},
    },

    created() {
        this.align = 'left'
    },

    methods: {
        async saveDeadline() {
            try {
                await axios.put(
                    `/clientDeadlines/${this.deadline.id}/assignment`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.assigned_to_id = this.deadline.assigned_to.id
        },

        setInitialKey() {
            this.key = `assignment${this.deadline.id}`
        },

        unFocus() {
            this.$refs.assignment.blur()
        },
    },

    computed: {
        ...mapState({
            accountingFirmUsers: (state) =>
                state.data.options.accountingFirmUsers,
        }),
    },
}
</script>

<style scoped>
.custom-select-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
